// extracted by mini-css-extract-plugin
export default {"message":"message__B3mlH"};